export const COVER_SHARE_BUTTONS_NOT_IN_VIEW = '[visibility] cover share buttons not in view'
export function coverShareButtonsNotInView() {
  return {
    type: COVER_SHARE_BUTTONS_NOT_IN_VIEW,
  }
}

export const COVER_SHARE_BUTTONS_IN_VIEW = '[visibility] cover share buttons in view'
export function coverShareButtonsInView() {
  return {
    type: COVER_SHARE_BUTTONS_IN_VIEW,
  }
}

export const TITLE_ABOVE_OR_BELOW_VIEWPORT = '[visibility] title above viewport'
export function titleAboveOrBellowViewport(isAbove) {
  return {
    type: TITLE_ABOVE_OR_BELOW_VIEWPORT,
    payload: { isAbove },
  }
}

export const SCROLL_DIRECTION_CHANGED = '[visibility] user changed scroll direction'
export function scrollDirectionChanged(isScrollUp) {
  return {
    type: SCROLL_DIRECTION_CHANGED,
    payload: { isScrollUp },
  }
}

export const SCROLL_UP_TREND = '[visibility] user  scroll up trend'
export function userScrollUpTrend(isScrollUpTrend) {
  return {
    type: SCROLL_UP_TREND,
    payload: { isScrollUpTrend },
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/visibility/visibility.actions.js